import { isAxiosError } from 'axios';
import { axiosAuth } from '@/axios';
import { Endpoints } from '@/enums';
import { UserData } from '@/types/auth';

export const updateUserData = async (
  newUserData: UserData
): Promise<unknown> => {
  try {
    const res = await axiosAuth.post(Endpoints.UpdateUserData, {
      ...newUserData,
    });
    return res;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
